import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import './MyOrdersPage.css';
import Preloader from '../common/preloader'; // ✅ 1. Import Preloader

const MyOrdersPage = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true); // ✅ 2. Add loading state

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchOrders = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
        return;
      }
      try {
        const response = await axios.get(`${API_BASE_URL}/api/orders`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        console.log('MyOrdersPage orders:', response.data);

        const cleanedOrders = response.data.map(order => ({
          orderId: order.orderId || 'N/A',
          totalPrice: order.totalPrice || 0,
          status: order.status || 'Processing',
          createdAt: order.createdAt ? new Date(order.createdAt).toLocaleString() : 'N/A',
          deliveryDetails: {
            name: order.deliveryDetails?.name || '',
            mobile: order.deliveryDetails?.mobile || '',
            address: order.deliveryDetails?.address || '',
            city: order.deliveryDetails?.city || '',
            state: order.deliveryDetails?.state || '',
            pincode: order.deliveryDetails?.pincode || '',
          },
          items: (order.items || []).map(item => ({
            id: item.productId || item.id || '',
            name: item.name || 'N/A',
            price: item.price || 0,
            quantity: item.quantity || 1,
            weight: item.weight || 'N/A',
            image: item.image ? item.image : '/placeholder-image.png',
          })),
        }));
        setOrders(cleanedOrders);
        setLoading(false); // ✅ 3. Stop loading
      } catch (error) {
        console.error('Error fetching orders:', error);
        setOrders([]);
        setLoading(false); // ✅ 4. Stop loading on error too
      }
    };
    fetchOrders();
  }, [navigate, API_BASE_URL]);

  const getStatusBadgeClass = (status) => {
    switch (status.toLowerCase()) {
      case 'cancelled':
        return 'mo-status-badge mo-canceled';
      case 'delivered':
        return 'mo-status-badge mo-delivered';
      default:
        return 'mo-status-badge mo-processing';
    }
  };

  // ✅ 5. Show preloader while loading
  if (loading) {
    return <Preloader />;
  }

  return (
    <div className="mo-container">
      <h1 className="mo-heading">My Orders</h1>
      {orders.length === 0 ? (
        <p className="mo-text-muted">You have no previous orders.</p>
      ) : (
        orders.map((order) => (
          <div key={order.orderId} className="mo-section">
            <div className="mo-order-header">
              <h2 className="mo-section-heading">Order Details</h2>
              <span className={getStatusBadgeClass(order.status)}>
                {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
              </span>
            </div>
            <div className="mo-cart-items">
              {order.items.map((item, index) => (
                <div
                  key={`${item.id}-${item.weight}-${index}`}
                  className="mo-cart-item d-flex align-items-center"
                >
                  <img
                    src={item.image}
                    alt={item.name}
                    className="img-fluid me-3"
                    style={{ maxWidth: '100px' }}
                  />
                  <div className="mo-item-details flex-grow-1">
                    <p className="mo-item-name">{item.name}</p>
                    <p className="mo-item-quantity">
                      Qty: {item.quantity}, Weight: {item.weight}
                    </p>
                    <p className="mo-item-price">
                      ₹{(item.price * item.quantity).toFixed(2)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mo-order-total">
              <span>Total Price:</span>
              <span className="mo-total-amount">
                ₹{order.totalPrice.toFixed(2)}
              </span>
            </div>
            <div className="mo-order-details">
              <p>
                <strong>Delivery Address:</strong> {order.deliveryDetails.name},{' '}
                {order.deliveryDetails.address}, {order.deliveryDetails.city},{' '}
                {order.deliveryDetails.state} - {order.deliveryDetails.pincode}
              </p>
              <p>
                <strong>Mobile:</strong> {order.deliveryDetails.mobile}
              </p>
              <p>
                <strong>Order Date:</strong> {order.createdAt}
              </p>
            </div>
            <div className="mo-action-buttons">
              <button
                className="mo-action-btn mo-track-btn"
                onClick={() => navigate(`/track-order/${order.orderId}`)}
              >
                Track Order
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default MyOrdersPage;
